/* eslint-disable class-methods-use-this */
import { Mark } from 'tiptap'
import { toggleMark } from 'tiptap-commands'

export default class setColor extends Mark {

  get name () {
    return 'setcolor'
  }

  get defaultOptions () {
    return {
      color: ['red'],
    }
  }

  get schema () {
    return {
      attrs: {
        color: {
          default: '#000000',
        },
      },
      parseDOM: [
        /*{
          tag: 'span[style]',
          getAttrs: dom => ({
            color: dom.getAttribute('style').split(":")[1],
          })
        },*/
        {
					style: 'color',
					getAttrs: value => ({ color: value }),
				},
        
       
      ],
      toDOM:
        node => {
          return ['span', {
            style: `color:${node.attrs.color}`
          }, 0]
        }
    }
  }

  commands ({ type }) {
    return (attrs) => toggleMark(type, attrs)
  }
}